module.exports = __webpack_public_path__ + "img/video_4.a26964da.png";